/**
 * Describes the cardinality of a relation.
 * All values are from Parent =\> Child.
 */
export enum RelationCardinality {
    /**
     * One parent to many children.
     */
    OneToMany,

    /**
     * Many parents to many children.
     */
    ManyToMany,

    /**
     * One parent to one child.
     */
    OneToOne,
}

export type RelationCardinalityType = "OneToMany" | "ManyToMany" | "OneToOne";
